import React, { FC, useEffect, useState, useRef, useMemo } from 'react';
import Styles from 'components/chatSideBar/chatParticipants/ChatParticipants.module.scss';
import superHostKey from 'assets/svg/superhost-user-key-indicator-for-avatar.svg';
import locationIcon from 'assets/svg/location.svg';
import ProfileAvatar from 'components/profileAvatar/ProfileAvatar';
import {getDistance, getMessageTime } from 'helpers/utils';
import { useGetMessages, getRoomLocation } from 'store/services/firebase-broadcast';
import { updateRoomStatus } from 'store/services/firebase-broadcast';
import { ref, onValue } from 'firebase/database';
import { db } from 'utils/firebase-config';

import moment from 'moment';
import { isArray } from 'lodash';
interface ChatParticipantsProps {
  isSuperHost?: boolean;
  offLineImageCss?: boolean;
  itemIndex: boolean;
  handleChangeIndex: Function;
  id: number;
  item: any;
  activateRoom?: any;
  setActiveRoom?: any;
  callBack?: any;
  selected?: any;
}

const ChatParticipants: FC<ChatParticipantsProps> = (props: ChatParticipantsProps) => {
  const { isSuperHost, offLineImageCss, itemIndex, handleChangeIndex, item,callBack, activateRoom, setActiveRoom, selected} = props;
  
  const [avatar, setAvatar] = useState('');
  const [name, setName] = useState('');
  // const [activateRoom, setActiveRoom] = useState<any>(null);
  const [hover, setHover] = useState(item?.pin ?? false);
  const user = JSON.parse(localStorage.getItem('user') as string);
  const [chatItem, setChatItem] = useState<any>(0)
  const [hasPendingRequests, setHasPendingRequests] = useState(false);
  
  // Get location data from Firebase
  const locationInfo = getRoomLocation(item);
  const getAdmin = () => {
    const host = item.host;
    if (host && host.profile && host.name) {
      setAvatar(host.profile);
      setName(host.name);
    }
  };

  // OPTIMIZED: Load only message count for unread notifications
  const { chat } = useGetMessages(item?.pk);
  const [unreadMessage, setUnreadMessage] = useState(0);
  

  
  // Real-time room data listener to get updated lastSeenMessage
  const [liveRoomData, setLiveRoomData] = useState(item);
  
  useEffect(() => {
    if (!item?.pk) return;
    
    const roomRef = ref(db, `rooms/${item.pk}`);
    const unsubscribe = onValue(roomRef, (snapshot) => {
      if (snapshot.exists()) {
        const updatedRoomData = snapshot.val();
        setLiveRoomData(updatedRoomData);
      }
    });
    
    return () => unsubscribe();
  }, [item?.pk]);

  // Unread count logic using live room data
  useEffect(() => {
    // The open room is always read.
    if (item?.pk === selected?.pk) {
      setUnreadMessage(0);
      return;
    }

    if (!chat?.length) {
      setUnreadMessage(0);
      return;
    }

    // My last-seen marker for this room, from the live room node.
    let me: any;
    if (liveRoomData?.host?.pk === user?.pk) {
      me = liveRoomData?.host;
    } else if (isArray(liveRoomData?.participants)) {
      me = liveRoomData?.participants?.find((p: any) => p?.pk === user?.pk);
    }

    // Exact, O(1), unbounded by the loaded window: unread = roomCount - what I've seen.
    // Preferred whenever the room has a counter (backfilled rooms + all new sends).
    if (typeof liveRoomData?.messageCount === 'number' && typeof me?.lastSeenCount === 'number') {
      setUnreadMessage(Math.max(0, liveRoomData.messageCount - me.lastSeenCount));
      return;
    }

    // Fallbacks below only apply to rooms not yet covered by the counter.
    // Compare by TIME, not by "find the last-seen id's index": the marker can be older
    // than the loaded window (id not present), which the old code miscounted as 0.
    // Also never count my own messages — I've obviously seen what I sent.
    const lastSeenTime = me?.lastSeenTime;

    if (lastSeenTime != null) {
      const count = chat.filter(
        (m: any) => getMessageTime(m) > lastSeenTime && m?.sender?.id !== user?.pk
      ).length;
      setUnreadMessage(count);
      return;
    }

    // Legacy fallback for rooms marked before lastSeenTime existed: id-index based.
    const lastSeenMessageId = me?.lastSeenMessage;
    if (lastSeenMessageId) {
      const lastSeenIndex = chat.findIndex((m: any) => m.id === lastSeenMessageId);
      if (lastSeenIndex !== -1) {
        const count = chat
          .slice(lastSeenIndex + 1)
          .filter((m: any) => m?.sender?.id !== user?.pk).length;
        setUnreadMessage(count);
        return;
      }
    }

    // No marker at all (or a marker we can't resolve): treat everything not sent by me
    // as unread, rather than silently showing 0.
    setUnreadMessage(chat.filter((m: any) => m?.sender?.id !== user?.pk).length);
  }, [
    chat,
    item?.pk,
    selected?.pk,
    liveRoomData?.messageCount,
    liveRoomData?.host?.lastSeenCount,
    liveRoomData?.host?.lastSeenTime,
    liveRoomData?.host?.lastSeenMessage,
    liveRoomData?.participants,
    user?.pk,
  ]);

  React.useEffect(() => {
    getAdmin();
  }, []);

  // Check for pending join requests (only for rooms where current user is the host)
  useEffect(() => {
    if (!item?.pk || item?.host?.pk !== user?.pk) {
      setHasPendingRequests(false);
      return;
    }
    
    // Only check for pending requests if current user is the host
    const requestsRef = ref(db, `requests/${item.pk}/requests`);
    const unsubscribe = onValue(requestsRef, (snapshot) => {
      if (snapshot.exists()) {
        const requests = snapshot.val();
        const requestCount = Object.keys(requests).length;
        setHasPendingRequests(requestCount > 0);
      } else {
        setHasPendingRequests(false);
      }
    });
    
    return () => unsubscribe();
  }, [item?.pk, item?.host?.pk, user?.pk]);

  if (!item || !item.pk) {
    console.warn('Invalid item in ChatParticipants:', item);
    return null;
  }

  const activeRoomFun = async (item: any) => { 
    //  setActiveRoom(item)
  }

  let participant;
  if (item?.participants?.length > 0) {
    participant = item?.participants.find((r: any) => r?.pk === user?.pk)
  }

  // const clickHandler = (item: any) => {
  //   let updateRoom = {
  //     room: item,
  //     pin: !hover,
  //     timeStamp: !hover ? moment().format(): ""
  //   };
  //   updateRoomStatus(updateRoom);
  //   setHover(!hover);
  // };
  return (
    <li>
      <div
        className={`${Styles.listingInner} ${
          itemIndex ? Styles.activeChat : ""
        }`}
        onKeyPress={() => handleChangeIndex(item)}
        onClick={() => (
          handleChangeIndex(item), activeRoomFun(item)//, clickHandler(item)//, callBack(item)
        )}
        tabIndex={0}
        role="button"
      >
        <div className={Styles.userImageWrapper}>
          <ProfileAvatar
            profile={item?.host?.profile}
            alt="card img"
            className={`${Styles.userImage} ${
              offLineImageCss ? Styles.offlineUserImage : ""
            } ${
              hasPendingRequests ? Styles.pendingRequestsImage : ""
            }`}
          />
          {isSuperHost && (
            <img
              src={superHostKey}
              alt="super host"
              className={Styles.superHostImg}
            />
          )}
        </div>
        <div className={Styles.userDetails}>
          <div className={Styles.userInner}>
            <h5>{item.topic}</h5>
            <p className={offLineImageCss ? Styles.offlineRoomName : ""}>
              {item?.host?.name ?? ""}
              &lsquo;s Room
            </p>
            {/* Location display - only show if not both Unknown */}
            {locationInfo.city !== "Unknown" && locationInfo.country !== "Unknown" && (
              <p className={Styles.locationText}>
                <img src={locationIcon} alt="location" className={Styles.locationIcon} />
                {[locationInfo.city, locationInfo.country].filter(Boolean).join(', ')}
              </p>
            )}
          </div>

          {
          // Only show unread count if user is in the room AND there are unread messages
          (item?.host?.pk === user?.pk || 
            (isArray(item?.participants) && item?.participants?.some((p: any) => p?.pk === user?.pk))) &&
          unreadMessage > 0
          ? (
            <div className={Styles.notifications}>
              <span className={`badge badge-pill ${Styles.badgeDanger}`}>
                {unreadMessage}
              </span>
            </div>
          ) : null}
        </div>
      </div>
    </li>
  );
};
export default ChatParticipants;
